import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/all' },
  { label: '排行榜', path: '/category/all?sort=popular' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path.split('?')[0]);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-book-open-line text-white text-lg"></i>
          </div>
          <span className="text-lg font-bold text-foreground-950 font-heading">4399漫画</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive(item.path)
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          {searchOpen ? (
            <div className="flex items-center bg-background-100 rounded-full px-3 py-1.5 border border-background-200/70">
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="bg-transparent border-none outline-none text-sm text-foreground-950 placeholder-foreground-400 ml-2 w-40"
                autoFocus
                onBlur={() => setSearchOpen(false)}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') setSearchOpen(false);
                }}
              />
            </div>
          ) : (
            <button
              onClick={() => setSearchOpen(true)}
              className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors text-foreground-600 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
          )}
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors text-foreground-600 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <div className="flex items-center bg-background-100 rounded-full px-3 py-2 mb-3 border border-background-200/70">
            <i className="ri-search-line text-foreground-400 text-sm"></i>
            <input
              type="text"
              placeholder="搜索漫画..."
              className="bg-transparent border-none outline-none text-sm text-foreground-950 placeholder-foreground-400 ml-2 w-full"
            />
          </div>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}